/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SendTypes {
  Single = 1,
  Phonebook = 2,
  Bulk = 3,
  Dynamic = 4,
  P2P = 5,
  Smart = 6,
  ApiSingle = 7,
  ApiP2P = 8,
  OTP = 9,
  Club = 10,
  Bulk2 = 11,
  OccasionPhonebook = 12,
  SmartP2P = 13,
  Device = 14
}
